(() => {
  'use strict';

  if (window.__fpSmartFilterScrollV02) return;
  window.__fpSmartFilterScrollV02 = true;

  const filterSelector = '.facets .facet-wrapper.facet-horizontal-wrapper .facet-filtering .facet-item > details.drop-menu';
  const margin = 12;
  let scheduled = false;

  function viewport() {
    const visual = window.visualViewport;
    const top = visual ? visual.offsetTop : 0;
    const left = visual ? visual.offsetLeft : 0;
    const height = visual ? visual.height : window.innerHeight;
    const width = visual ? visual.width : window.innerWidth;
    return { top, left, bottom: top + height, right: left + width, height, width };
  }

  function positionFilter(details, view) {
    const menu = details.querySelector(':scope > .facet-display.drop-menu-wrapper');
    const summary = details.querySelector(':scope > summary');
    if (!menu || !summary) return;

    if (!details.open) {
      menu.classList.remove('fp-viewport-overlay');
      menu.classList.remove('pop-from--top');
      menu.style.removeProperty('--fp-filter-available-height');
      menu.style.removeProperty('--fp-filter-overlay-top');
      menu.style.removeProperty('--fp-filter-overlay-left');
      menu.style.removeProperty('--fp-filter-horizontal-shift');
      return;
    }

    const rect = summary.getBoundingClientRect();
    const below = Math.max(0, view.bottom - rect.bottom - margin);
    const above = Math.max(0, rect.top - view.top - margin);
    const expected = Math.min(320, Math.max(100, menu.scrollHeight));
    const useTop = below < expected && above > below;
    const available = useTop ? above : below;
    const compact = available < 76;

    menu.classList.toggle('pop-from--top', useTop && !compact);
    menu.classList.toggle('fp-viewport-overlay', compact);

    if (compact) {
      menu.style.removeProperty('--fp-filter-horizontal-shift');
      const width = Math.min(menu.offsetWidth || 320, view.width - margin * 2);
      const left = Math.min(Math.max(rect.left, view.left + margin), view.right - margin - width);
      menu.style.setProperty('--fp-filter-overlay-top', `${Math.round(view.top + margin)}px`);
      menu.style.setProperty('--fp-filter-overlay-left', `${Math.round(Math.max(view.left + margin, left))}px`);
      menu.style.setProperty('--fp-filter-available-height', `${Math.max(1, Math.floor(view.height - margin * 2))}px`);
    } else {
      menu.style.removeProperty('--fp-filter-overlay-top');
      menu.style.removeProperty('--fp-filter-overlay-left');
      menu.style.setProperty('--fp-filter-available-height', `${Math.max(1, Math.floor(available))}px`);
      if (typeof menu.getBoundingClientRect === 'function') {
        const menuRect = menu.getBoundingClientRect();
        const previous = Number.parseFloat(menu.style.getPropertyValue('--fp-filter-horizontal-shift')) || 0;
        const maxLeft = view.left + margin;
        const maxRight = view.right - margin;
        let delta = 0;
        if (menuRect.left < maxLeft) delta = maxLeft - menuRect.left;
        else if (menuRect.right > maxRight) delta = maxRight - menuRect.right;
        menu.style.setProperty('--fp-filter-horizontal-shift', `${Math.round(previous + delta)}px`);
      }
    }
  }

  function update() {
    const view = viewport();
    document.documentElement.style.setProperty('--fp-visible-viewport-height', `${Math.max(1, Math.floor(view.height))}px`);
    document.documentElement.style.setProperty('--fp-visible-viewport-top', `${Math.round(view.top)}px`);

    document.querySelectorAll(filterSelector).forEach((details) => positionFilter(details, view));

    document.querySelectorAll('.section-header predictive-search, .section-header search-form').forEach((search) => {
      if (!search.classList.contains('in-focus') && !search.hasAttribute('open')) return;
      const panel = search.querySelector('.search-container');
      if (!panel) return;
      const top = panel.getBoundingClientRect().top;
      const available = Math.max(1, Math.floor(view.bottom - top - margin));
      search.style.setProperty('--fp-search-available-height', `${available}px`);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  }

  function init() {
    schedule();
    document.addEventListener('toggle', (event) => {
      if (event.target.matches?.(filterSelector)) schedule();
    }, true);
    document.addEventListener('focusin', (event) => {
      if (event.target.closest?.('.section-header .search-wrapper')) schedule();
    }, true);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();